import React from 'react';
import { ReferencePage } from './ReferencePage';
import { ContractorNewForm } from '../../components/ContractorNewForm';
import { useData } from '../../contexts/DataContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { TABLE_COLUMNS } from '../../constants/tables';
import { ContractorNew } from '../../types';

export const ContractorsPage: React.FC = () => {
  const { t } = useLanguage();
  const { contractors } = useData();

  return (
    <ReferencePage<ContractorNew>
      title={t('references.contractors')}
      items={contractors.items}
      columns={TABLE_COLUMNS.CONTRACTORS}
      onAdd={contractors.add}
      onEdit={contractors.edit}
      onDelete={contractors.remove}
      renderForm={({ theme, initialData, onSubmit, onCancel }) => (
        <ContractorNewForm
          theme={theme}
          initialData={initialData}
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      )}
    />
  );
};
